export default __webpack_public_path__ + "static/media/Cardo.a0c1dc80.ttf";